import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';

const MyJobsWidget = ({ onClick }) => {
  return (
    <Card 
      onClick={onClick}
      sx={{ 
        cursor: 'pointer',
        height: '100%',
        transition: 'all 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 3
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <CalendarIcon sx={{ fontSize: 28, color: 'primary.main', mr: 1 }} />
          <Typography variant="h6" component="div" fontWeight="bold">
            Mine Jobber
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Se dine planlagte produksjonsjobber
        </Typography>
      </CardContent>
    </Card>
  );
};

export default MyJobsWidget;
